import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { DishAdLabel } from 'app/components/ui/Elements/DishAdLable/DishAdLabel';
import { DishDetailsCounter } from './DishDetailsCounter';

import './dish-details.scss';


export function DishDetailsPicture(props) {
    const {
        imageUrl,
        imageUrlDesktop,
        alt,
    } = props;

    const [hasImageLoadingError, setHasImageLoadingError] = useState(false);

    const handleImageLoadError = useCallback(() => {
        setHasImageLoadingError(true);
    }, []);

    return (
        <picture>
            <source media="(max-width: 1023px)" srcSet={hasImageLoadingError ? imageUrlDesktop : imageUrl} />
            <source media="(min-width: 1024px)" srcSet={imageUrlDesktop} />
            <img styleName="ny__details-image__img" alt={alt} onError={handleImageLoadError} />
        </picture>
    );
}


export default function DishDetailsImage({
    portion = 0,
    id,
    canChangePortionsCount = true,
    ...imageProps
}) {
    return (
        <div styleName="ny__details-image__root">
            <DishAdLabel id={id} />
            <DishDetailsPicture {...imageProps} />
            {canChangePortionsCount && <DishDetailsCounter portion={portion} />}
        </div>
    );
}

DishDetailsImage.propTypes = {
    id: PropTypes.string.isRequired,
    portion: PropTypes.number,
    canChangePortionsCount: PropTypes.bool,
};
